import { useDropzone } from "react-dropzone";
import { upload } from "System/system";
import { useSelector, useDispatch } from "react-redux";
// --------------------------------------------
import CheckinProgress from "./CheckinProgress";
import { startUnzipping } from "Redux/conversions/actions";
// --------------------------------------------

// --------------------------------------------
// --------------------------------------------
const Checkin = () => {
  const dispatch = useDispatch();
  const {id} = useSelector((state) => state.project);

  const onDrop = async (acceptedFiles) => {
    dispatch({
      type: "SHOW_HIDE_CONVERTERS",
      showConverters: true,
    });
    const formData = new FormData();
    formData.append("filetoupload", acceptedFiles[0]);
    formData.append("projectid", id);
    const result = await upload(formData, (pointer) => {
      dispatch({
        type: "SET_CHECKIN_PROGRESS",
        pointer,
        ext: "upload",
      });
    });
    const {
      data: { originalFolder, tag },
    } = result; // "tag" is the modified title of the zip
    dispatch(startUnzipping(originalFolder, tag));
  };

  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  return (
    <div>
      <CheckinProgress />
      <div className="drop-zone-wrapper">
        <div {...getRootProps()} className="drop-zone">
          <input {...getInputProps()} />
          <i className="fa-duotone fa-file-archive zipper" />
        </div>
      </div>
    </div>
  );
};

export default Checkin;
